export const formatDuration = (durationInMinutes?: number): string => {
  if (durationInMinutes === undefined) return "";
  if (durationInMinutes === 0) return "Less than 1 minute";
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;
  const formattedHours = hours ? `${hours} ${hours === 1 ? "hour" : "hours"}` : "";
  const formattedMinutes = minutes ? `${minutes} ${minutes === 1 ? "minute" : "minutes"}` : "";
  return `${formattedHours}${formattedHours && formattedMinutes ? " " : ""}${formattedMinutes}`;
};
